class NavbarController {
    constructor($scope, $state, userLogin,NotificationAPI, $typeMap, $uibModal,Jurisdiction) {
        "ngInject";
        this.$uibModal = $uibModal
        $scope.user = this.appUser;
        this.Jurisdiction = Jurisdiction
        $scope.logout = () => {
            userLogin.logout().then(() => {
                window.localStorage.removeItem("loginUser")
                $state.go('app.face.index.frontpage');
            });
        };
        this.$state = $state
        this.typeMap = $typeMap
        this.permission =  JSON.parse(window.localStorage.getItem("loginUser"))
        $scope.isGuest = userLogin.isGuest;
        $scope.$state=$state;
        this.jurisdiction()
        this.NotificationAPI=NotificationAPI;
        if(!$scope.isGuest()){
            this.loadMessages()
        }
    }
    loadMessages() {
        let self = this;
        this.NotificationAPI.one('top5').get().then(
            (res) => {
                if(res.status.code==200){
                    self.last_query_time=res.data.last_query_time
                    self.unread_count=res.data.unread_count;
                    self.messages = res.data.notifications;
                }else{
                    self.message.error(res.status.message);
                }

            },
            (err) => {
                self.message.error(err.data);
            }
        );
    }
    readAll(){
        //全部已读
        let self = this
        this.NotificationAPI.one().get({page: 15,page_size:1}).then(
            (res) => {
                if(res.status.code==200){
                    self.unread_count=0;
                    self.last_query_time=+(new Date().getTime()/1000);
                }else{
                    self.message.error(res.status.message);
                }

            },
            (err) => {
                self.message.error(err.data);
            }
        );
    }
  
    openDownload() {
      this.$uibModal.open({
        animation: true,
        component: 'downlistModal',
        windowClass: 'dd-modal'
      })
    }

    jurisdiction(route_name){
        
        let params = Object.assign(this.permission,{route_name:route_name,checkType:"route"})
        return this.Jurisdiction.checkStatus(params) 
    }
    checkRole(){
      //  console.log()
      //  this.permission.role_type === 1
       return this.permission.role_type === 1
    }

    
}

export default NavbarController;



// WEBPACK FOOTER //
// ./src/app/common/navbar/navbar.controller.js